import React from 'react';
import ErrorBoundary from "./ErrorBoundary";
import Editor, { loader, DiffEditor } from "@monaco-editor/react";



const ApprovalConfigEditor = ({ clientConfig={}, isDiff=false, newConfig={} }) => {
  
  loader.init().then(monaco => {
    monaco.languages.json.jsonDefaults.setDiagnosticsOptions({
      validate: false
    });
  });

  const options = {
    mouseWheelZoom: true,
    smoothScrolling: true,
    colorDecorators: true,
    readOnly: true
  };

  return (
    <>
      {(!isDiff) ? (
      <ErrorBoundary>
        <div className="bg-white">
          <Editor
            height="82vh"
            defaultLanguage="json"
            defaultValue={JSON.stringify(clientConfig, null, 2)}
            options={options}
          />
        </div>
      </ErrorBoundary>
      ) : (
      <ErrorBoundary>
        <div className="bg-white">
          <DiffEditor
            height="82vh"
            original={JSON.stringify(clientConfig, null, 2)}
            modified={JSON.stringify(newConfig, null, 2)}
            defaultLanguage="json"
            options={options}
          />
        </div>
      </ErrorBoundary>
      )}
    </>
  );
};

export default ApprovalConfigEditor;
